import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { Plugin as Fragment } from 'vue-fragment';
import VueClipboard from 'vue-clipboard2';
import VueVirtualScroller from 'vue-virtual-scroller';
import appSettingsProvider from '@/appsettings';

import 'ress/dist/ress.min.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import 'vue-slider-component/theme/default.css';

import TheSourceUI from '../src/components/the-source-ui';
import Widgets from '../src/components/widgets';

import App from './App.vue';
import router from './router';
import store from './store';

window.AppConfig = {};

window.config = (key, defaultValue) => {
  if (!key) return window.AppConfig;

  try {
    return key.split('.').reduce((prev, curr) => {
      return prev[curr];
    }, window.AppConfig)
  } catch (err) {
    return defaultValue;
  }
}

window.appId = location.hostname.split('.')[0];

window.app = (key, defaultValue) => {
  return window.config(
    key,
    defaultValue
  );
}

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(Fragment);
Vue.use(VueClipboard);
Vue.use(VueVirtualScroller);
Vue.use(TheSourceUI);
Vue.use(Widgets);

window.EventBus = new Vue();

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!el.contains(event.target)) {
        vnode.context[binding.expression](event);
      }
    };

    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
});

appSettingsProvider.then(settings => {
  window.AppConfig = settings;
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}).catch(err => console.error('Could not load settings'))